import React from "react";
import ReactGA from "react-ga";
import gpxImage from "../images/GPX.svg";
import kmlImage from "../images/KML.svg";
import _ from "lodash";
import { getCurrentPage } from "../helpers";

class RoutePlanDownload extends React.Component {
    state = {
        gpxLink: "",
        kmlLink: gpxImage,
        gpxImage: kmlImage,
    };

    componentDidMount() {
        this.fetchRouteDownloads();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.currentJourney.currentJourney !==
            this.props.currentJourney.currentJourney
        ) {
            this.fetchRouteDownloads();
        }
    }

    fetchRouteDownloads = () => {
        const current = this.props.currentJourney.currentJourney;
        const downloadFiles = this.props.cycleRoutes[current].download_files;

        this.setState({
            gpxLink: downloadFiles.gpx,
            kmlLink: downloadFiles.kml,
        });
    };

    render() {
        const { gpxLink, kmlLink } = this.state;
        return (
            <div>
                <h2>Download route</h2>
                <div className="downloads">
                    <a
                        className="button button--primary"
                        href={gpxLink}
                        download
                        onClick={(e) => {
                            ReactGA.event({
                                category: _.startCase(getCurrentPage()),
                                action: "Download GPX",
                                label: "GPX route download",
                            });
                        }}
                    >
                         <img src={gpxImage} alt="Download GPX file" />
                    </a>
                    <a
                        className="button button--primary"
                        href={kmlLink}
                        download
                        onClick={(e) => {
                            ReactGA.event({
                                category: _.startCase(getCurrentPage()),
                                action: "Download KML",
                                label: "KML route download",
                            });
                        }}
                    >
                        <img src={kmlImage} alt="Download kml file" /> 
                    </a>
                </div>
            </div>
        );
    }
}

export default RoutePlanDownload;



// WEBPACK FOOTER //
// ./src/components/RoutePlanDownload.js